/* eslint-disable jsx-a11y/anchor-is-valid */

import React, { Component } from 'react';
import {Card, Button} from 'reactstrap';
import CdnImage from '../../../components/cdnImage/cdnImage.js'
import HolidayDialogue from './HolidayDialogue';
import HeaderComponent from "../../../components/header/HeaderComponent";
import ErrorComponent from '../../../components/error/ErrorComponent.js'
import LoadingComponent from '../../../components/loading/LoadingComponent'
import { LuRefreshCw, LuXCircle } from "react-icons/lu";

const stringUtil = require('../../../utils/string/stringUtil.js');
const guidUtil = require('../../../utils/guid/guidUtil.js');
const commonUtility = require('../../../utils/domain/commonUtility.js');
const dateUtil = require('../../../utils/dateUtil/dateUtil.js');
const typeUtil = require('../../../utils/type/typeUtil.js');
const viewUtil = require('../../../utils/view/viewUtil.js');
const rmsApiProxyRetry = require('../../../utils/api/rmsApiProxyRetry.js');
const jobsServer = require('../../../utils/jobs/jobsServer')
const configurationManager = require('../../../utils/config/configurationManager.js');
const themeUtil = require('../../../utils/view/themeUtil.js');
const staffUtility = require('../../../utils/domain/staff/staffUtility.js');
const logger = require('../../../utils/logger/logger.js');
const stateManager = require('../../../utils/state/stateManager.js');
const translator = require('../../../utils/translator/translator.js');

const screenKeyboardAction = require('../../../utils/state/actions/views/onScreenKeyboard/screenKeyboardAction.js');
const navigationPageAction = require('../../../utils/state/actions/views/navigationPage/navigationPageAction.js');

const noOfAdvancedMonths = 6;
const noOfDaysWhenBookingNotAllowed = 20;

const localToday = dateUtil.getDateComponent(dateUtil.convertToLocalStandard(dateUtil.getNow()));

class HolidaysView extends Component 
{
    constructor(props)
    {
        super(props);
     
        this.renderBody = this.renderBody.bind(this);
        this.renderError = this.renderError.bind(this);
        this.renderLoadingBody = this.renderLoadingBody.bind(this);
        this.renderHolidayCalendar = this.renderHolidayCalendar.bind(this);
        this.renderHolidayCalendarMonth = this.renderHolidayCalendarMonth.bind(this);
        this.renderBookedHolidays = this.renderBookedHolidays.bind(this);
        this.renderStaffNameCell = this.renderStaffNameCell.bind(this);
        this.renderHolidayDialogue = this.renderHolidayDialogue.bind(this);

        this.onRefreshButton = this.onRefreshButton.bind(this);
        this.onBackButton = this.onBackButton.bind(this);
        this.onBookedHolidayClick = this.onBookedHolidayClick.bind(this);
        this.onBookedHolidayDelete = this.onBookedHolidayDelete.bind(this);

        this.updateServerWithHoliday = this.updateServerWithHoliday.bind(this);
       
        this.state = {};
        this.state.bookedHolidays = [];
        this.state.stage = 'loading';
        this.state.startDate = dateUtil.getStartOfMonth(localToday);
        this.state.endDate = dateUtil.getEndOfMonth(dateUtil.addMonths(this.state.startDate, noOfAdvancedMonths));
        this.state.bookingStartDate = dateUtil.addDays(localToday, noOfDaysWhenBookingNotAllowed);
        
   }

    render()
    {
        return  <div className='h-100'>
                    {this.renderToolbar()}
                    {this.renderBody()}
                </div>;
    }

    renderToolbar()
    {
        return  <HeaderComponent title={this.props.title}>
                    <div className='flex-row d-flex' style={{justifyContent: 'flex-end'}}>
                        <div style={{marginRight:'70px'}}>
                            <Button className='btn-action' style={{minWidth:'5vw'}}
                                    onClick={() => 
                                        {
                                            logger.usage("Holidays.Refresh", "Staff clicked refresh button to refresh attendance");
                                            this.onRefreshButton();
                                        }}>
                                <LuRefreshCw/>
                            </Button>
                        </div>
                        
                        <Button className='btn-cancel'
                                onClick={()=>
                                    {
                                        logger.usage("Holidays.Exit", "Staff clicked exit button to exit");
                                        this.state.unmounted = true;
                                        stateManager.getStore().dispatch(screenKeyboardAction.createAction(null));
                                        stateManager.getStore().dispatch(navigationPageAction.createAction(null))
                                    }}>{translator.getLabel("exit")}
                        </Button>
                    </div>
                </HeaderComponent>
    }

    renderBody()
    {
        if (!stringUtil.isStringNullOrEmpty(this.state.error))
            return this.renderError();

        if (stringUtil.areStringSame(this.state.stage, "loading"))
            return this.renderLoadingBody();

        var height = window.innerHeight;
        return  <div>
                    <div style={{overflowY:'auto', height:height}}>
                        {this.renderHolidayCalendar()}
                    </div>
                    {this.renderHolidayDialogue()}
                </div>;
    }

    renderError()
    {
        return  <div className='h-50 caption primary-color d-flex flex-column justify-content-center align-items-center'>
                    <ErrorComponent error={this.state.error}/>
                </div>
    }

    renderLoadingBody()
    {

        var rotaResourceUrl = `${rmsApiProxyRetry.getOrgContextToUrl()}/hr/holidays?fromDate=${this.state.startDate}&toDate=${this.state.endDate}`;
        rmsApiProxyRetry.get(rotaResourceUrl)
            .then(results =>
            {
                if (results == null)
                    results = [];

                results.forEach (result =>
                {
                    result.isLocked = false;
                    result.isDisabled = false;

                    if (stringUtil.areStringSame(result.status, "approved") || stringUtil.areStringSame(result.status, "rejected") ||
                        dateUtil.isSameOrBefore(dateUtil.getDateComponent(result.fromDate), this.state.bookingStartDate))
                        result.isLocked = true;

                    if (!stringUtil.areStringSame(result.staffId, staffUtility.getLoginStaff().id))
                        result.isDisabled = true;
                        
                });
                this.state.bookedHolidays = results;
                this.state.stage = "loaded";
                this.setState({});
            }, error =>
            {
                this.state.error = error;
                this.setState({});
            });

        return this.showLoader();
    }

    showLoader()
    {
        return  <div className='h-50 caption primary-color d-flex flex-column justify-content-center align-items-center'>
                    <LoadingComponent waitMessage={translator.getLabel("please_wait_loading_rota")}/>
                </div>
    }

    renderHolidayCalendar()
    {
        var monthsComponent = [];
        var currentDate = this.state.startDate;
        while (currentDate <= this.state.endDate)
        {
            monthsComponent.push(<div>
                                    <h4 style={{color:'#989898', margin:'2.5rem 0px 1rem 1rem'}}>{dateUtil.formatDate(currentDate, "MMMM, yyyy")}</h4>
                                    {this.renderHolidayCalendarMonth(currentDate)}
                                </div>)
            currentDate = dateUtil.addMonths(currentDate, 1);
        }

        return monthsComponent;
    }

    getDateCaption(currentDate)
    {
        return dateUtil.isSame(currentDate, localToday) ? <div className='flex-row d-flex' style={{justifyContent: 'flex-end'}}><div style={{color:'var(--colors-primary)', marginRight: '0.5rem'}}>{translator.getLabel("today")}</div> {dateUtil.formatDate(currentDate, "DD/MMM")}</div> : dateUtil.formatDate(currentDate, "DD/MMM")
    }

    renderHolidayCalendarMonth(startOfMonthDate)
    {
        var tableHeaders = [];
        tableHeaders.push(<th style={{textAlign:'center', verticalAlign:'center'}}>Sun</th>);
        tableHeaders.push(<th style={{textAlign:'center', verticalAlign:'center'}}>Mon</th>);
        tableHeaders.push(<th style={{textAlign:'center', verticalAlign:'center'}}>Tue</th>);
        tableHeaders.push(<th style={{textAlign:'center', verticalAlign:'center'}}>Wed</th>);
        tableHeaders.push(<th style={{textAlign:'center', verticalAlign:'center'}}>Thr</th>);
        tableHeaders.push(<th style={{textAlign:'center', verticalAlign:'center'}}>Fri</th>);
        tableHeaders.push(<th style={{textAlign:'center', verticalAlign:'center'}}>Sat</th>);

        var currentDate = startOfMonthDate;
        let tableRows = [];
        while (dateUtil.getMonth(currentDate) == dateUtil.getMonth(startOfMonthDate))
        {
            let dateComponents = [];
            for (var iCol = 0; iCol <= 6; iCol++)
            {
                if (dateUtil.getDay(currentDate) == iCol && dateUtil.getMonth(currentDate) == dateUtil.getMonth(startOfMonthDate))
                {
                    var bookedHolidays = this.renderBookedHolidays(currentDate);
                   
                    var backgroundColor = "var(--colors-white)";
                    var clickHandler = ()=>{viewUtil.showErrorAlert(translator.getLabel("selected_date_is_locked_and_cannot_accept_any_further_holiday_requests"))}
                    if (dateUtil.isBefore(currentDate, localToday))
                    {
                        backgroundColor = 'var(--colors-neutral-dark)';
                    }
                    else if (dateUtil.isSame(currentDate, localToday))
                    {
                        backgroundColor = 'var(--background-color)';
                    }
                    else if (dateUtil.isBefore(currentDate, this.state.bookingStartDate))
                    {
                        backgroundColor = 'var(--colors-not-available)';
                    }
                    else
                    {
                        let bookingDate = currentDate;
                        clickHandler = ()=>{
                                                logger.usage("Holidays.New.Holiday", "Staff clicked a date to request a holiday");
                                                var currentStaff = staffUtility.getLoginStaff();
                                                var bookedHolidays = this.findBookedHolidaysForDate(bookingDate);
                                                if (bookedHolidays.find(b => stringUtil.areStringSame(b.staffId, currentStaff.id) &&
                                                                             !stringUtil.areStringSame(b.status, "rejected") ) != null)
                                                {
                                                    viewUtil.showErrorAlert(`${translator.getLabel("there_is_already_an_existing_booking_for_staff")} ${currentStaff.lastName} ${currentStaff.firstName}`);
                                                    return;
                                                }

                                                var holiday = {};
                                                holiday.id = guidUtil.generateGuid();
                                                holiday.staffId = currentStaff.id;
                                                holiday.propertyId = commonUtility.getProperty().id;
                                                holiday.fromDate = bookingDate;
                                                holiday.toDate = bookingDate;
                                                holiday.status = "pending";
                                                holiday.isFullDay = true;
                                                holiday.isLocked = false;
                                                holiday.isDisabled = false;
                                                
                                                this.state.bookedHoliday = holiday;
                                                this.setState({});
                                           }
                    }

                    dateComponents.push(<td style={{width:'14%', background:backgroundColor, verticalAlign:'top'}} onClick={clickHandler}>
                                            <div style={{minHeight:'150px', width:'100%'}}>
                                                <div style={{textAlign:'right'}}>
                                                    {this.getDateCaption(currentDate)}
                                                </div>
                                                {bookedHolidays.length > 0 ?  <div style={{marginTop:'10px'}}>{bookedHolidays}<div style={{minHeight:'50px'}}></div></div> : null}
                                            </div>
                                        </td>);

                    currentDate = dateUtil.addDays(currentDate, 1);
                }
                else
                {
                    dateComponents.push(<td style={{background:'var(--colors-neutral-dark)'}}><div style={{minHeight:'150px', width:'100%', textAlign:'right'}}></div></td>)
                }
            }

            tableRows.push(<tr>{dateComponents}</tr>);
        }

        return (<table width="100%" class="pure-table pure-table-bordered">
                    <thead>
                        <tr style={{background: 'var(--colors-neutral'}}>
                            {tableHeaders}
                        </tr>
                    </thead>
                    <tbody>
                        {tableRows}
                    </tbody>
                </table>);
    }

    onRefreshButton()
    {
        this.state.stage = 'loading';
        this.setState({});
    }

    onBackButton()
    {
        this.props.history.push('/');
    }

    renderBookedHolidays(bookingDate)
    {

        var bookedHolidays = this.findBookedHolidaysForDate(bookingDate);
        var bookedHolidayComponents = [];

        bookedHolidays.forEach (bookedHoliday =>
        {
            var staff = staffUtility.getAllStaff().find (s => s.id == bookedHoliday.staffId);
            var name = `${staff.firstName} ${staff.lastName}`;

            var imageComponent = null;
            if (!stringUtil.isStringNullOrEmpty(staff.pictUrl))
                imageComponent = <div> <CdnImage  cloudName={configurationManager.getConfig().cdnUsersCloudName} publicId={staff.pictUrl} width="30" height="30" radius="0"/></div>;
            else
                imageComponent = <div> <CdnImage  cloudName={configurationManager.getConfig().cdnAppCloudName} publicId={themeUtil.getPublicId('staff.png')} width="30" height="30" radius="0"/></div>;

            var cardColor = "success";
            if (stringUtil.areStringSame(bookedHoliday.status, "pending"))
                cardColor = "primary";
            else if (stringUtil.areStringSame(bookedHoliday.status, "rejected"))
                cardColor = "danger";

            var deleteButton = null;
            if (!bookedHoliday.isLocked && !bookedHoliday.isDisabled)
            {
                deleteButton =  <div
                                    onClick={(e)=>
                                        {
                                            this.onBookedHolidayDelete(bookedHoliday); 
                                            e.stopPropagation();
                                        }}>
                                    <LuXCircle style={{color:'white', fontSize:'1.5rem'}}/>
                                </div>
            }
            
            bookedHolidayComponents.push(<Card className="p-3" color={cardColor} onClick={(e)=>{this.onBookedHolidayClick(bookedHoliday); e.stopPropagation();}}>
                                                <div className='d-flex flex-row' style={{position:'relative', justifyContent: 'center', alignItems: 'flex-start'}}>
                                                    {imageComponent}
                                                    <div style={{position:'absolute', right: '-0.5rem', top: '-0.5rem'}}>{deleteButton}</div>
                                                </div>
                                                <div style={{minWidth:'0px', margin:'5px 0px 0px 0px', padding:'0px', textAlign:'center', color:'white'}}>{name}</div> 
                                                <div style={{textAlign:'center', color:'white'}}>
                                                    <small>{this.createCaption(bookedHoliday)}</small>
                                                </div>
                                        </Card>);
        });


        return bookedHolidayComponents;
    }

    onBookedHolidayClick(bookedHoliday)
    {
        logger.usage("Holidays.Existing.Holiday", "Staff clicked an existing request to view/edit a holiday");
        if (bookedHoliday.isDisabled)
            return;

        this.state.bookedHoliday = bookedHoliday;
        this.setState({});
    }

    onBookedHolidayDelete(bookedHoliday)
    {
        viewUtil.showPrompt(translator.getLabel("Remove"), `${translator.getLabel("you_are_going_to_remove_holiday_booking_for_period")} ${this.createCaption(bookedHoliday)}`, `${translator.getLabel("are_you_sure_you_want_to_continue")}`, ()=>
        {
            this.state.bookedHolidays = this.state.bookedHolidays.filter(b => !stringUtil.areStringSame(bookedHoliday.id, b.id));
            this.updateServerWithHoliday(bookedHoliday, true);
            this.setState({});
        });
        
    }

    createCaption(bookedHoliday)
    {
        var caption = `${translator.getLabel("full_day")} (${dateUtil.formatDate(bookedHoliday.fromDate, "DD/MMM")} - ${dateUtil.formatDate(bookedHoliday.toDate, "DD/MMM")})`;
            if (!bookedHoliday.isFullDay)
                caption = `${dateUtil.formatDate(dateUtil.convertToLocalStandard(bookedHoliday.fromDate), "HH:mm")} - ${dateUtil.formatDate(dateUtil.convertToLocalStandard(bookedHoliday.toDate), "HH:mm")}`;
        
        return caption;
    }

    renderStaffNameCell(attendanceStaff)
    {
        var name = `${attendanceStaff.firstName} ${attendanceStaff.lastName}`;
        var imageComponent = null;
        if (!stringUtil.isStringNullOrEmpty(attendanceStaff.pictUrl))
            imageComponent = <div style={{marginRight:'10px'}}> <CdnImage  cloudName={configurationManager.getConfig().cdnUsersCloudName} publicId={attendanceStaff.pictUrl} width="30" height="30" radius="0"/></div>;
        else
            imageComponent = <div style={{marginRight:'10px'}}> <CdnImage  cloudName={configurationManager.getConfig().cdnAppCloudName} publicId={themeUtil.getPublicId('staff.png')} width="30" height="30" radius="0"/></div>;

        return (<table style={{border:'none !important'}}>
                    <tr>
                        <td style={{border:'none !important'}}>
                            {imageComponent}
                        </td>
                    </tr>
                    <tr>
                        <td style={{textAlign:'center', border:'none !important'}}>
                            {name} - {translator.getLabel("full_day")}
                        </td>
                    </tr>
                </table>)
    }

    renderHolidayDialogue()
    {
        if (!this.state.bookedHoliday)
            return;

        return (<HolidayDialogue bookedHoliday={typeUtil.deepCloneObject(this.state.bookedHoliday)}
                onSave = {(updatedHoliday)=>
                            {
                                this.state.bookedHolidays = this.state.bookedHolidays.filter(b => !stringUtil.areStringSame(this.state.bookedHoliday.id, b.id));
                                this.state.bookedHolidays.push(updatedHoliday);
                                this.updateServerWithHoliday(updatedHoliday, false);
                                this.state.bookedHoliday = null;
                                this.setState({});
                            }
                        }
                onCancel={()=>{
                                this.state.bookedHoliday = null;
                                this.setState({});
                            }
                        } />)
    }

    findBookedHolidaysForDate(bookingDate)
    {
        return this.state.bookedHolidays.filter(b => dateUtil.isSameOrAfter(bookingDate, dateUtil.getDateComponent(dateUtil.convertToLocalStandard(b.fromDate))) &&
                                                     dateUtil.isSameOrBefore(bookingDate, dateUtil.getDateComponent(dateUtil.convertToLocalStandard(b.toDate))));
    }

    updateServerWithHoliday(updatedHoliday, isDelete)
    {

        var payload = {};
        payload.action = isDelete ? "delete" : "submit";
        payload.holiday = updatedHoliday;

        jobsServer.addJob(guidUtil.generateGuid(), "Jobs.Server.Holidays.Saving", 
                        ()=>
                        {
                                var rotaResourceUrl = `${rmsApiProxyRetry.getOrgContextToUrl()}/hr/holidays`;
                                return rmsApiProxyRetry.post(rotaResourceUrl, payload)
                        });
    }
}

export default HolidaysView;